define('modules/integrations/services/api/view',['require','exports','module','jquery','views/BaseView','views/AlertView','views/ModalView','ThemesHelper','modules/integrations/services/api/secretData/view','env','ldsh!./template','ldsh!./template_api_not_enabled'],function (require, exports, module) {
  "use strict";

  var $ = require("jquery"),
    BaseView = require("views/BaseView"),
    AlertView = require("views/AlertView"),
    ModalView = require("views/ModalView"),
    ThemesHelper = require("ThemesHelper"),
    SecretDataView = require("modules/integrations/services/api/secretData/view"),
    Config = require("env");

  var Layout = BaseView.extend({
    template: require("ldsh!./template"),
    apiKeysData: [],
    alertView: null,

    events: {
      "click #upgradeProducts": "paymentsRedirect",
    },

    getCurrentCompanyId: function () {
      return this.group.get("selectedCompany") || this.group.get("id");
    },

    loadAPIKeys: function () {
      var self = this;
      this.collection.fetch({
        data: {
          companyId: this.getCurrentCompanyId(),
        },
        success: function (collection) {
          self.apiKeysData = collection.models;
        },
      });
    },

    initialize: function () {
      var self = this;
      this.alertView = null;

      if (!this.group.checkApiIsEnabled()) {
        this.template = require("ldsh!./template_api_not_enabled");
        return;
      }
      if (!this.collection.isRequest) {
        this.loadAPIKeys();
      }

      this.listenTo(this.collection, "reset sync request error", function () {
        self.render();
        self.initAlerts();
      });
    },

    blockGroupSelector: function () {
      var $groupOption = $("#integrations")
        .find("#company-drop-menu")
        .find(".company-selector")
        .first();

      $groupOption.addClass("disabled").on("click", function (e) {
        e.preventDefault();
        return false;
      });
    },

    beforeRender: function () {},

    initEvents: function () {
      var self = this;

      this.$el
        .find("#apiTokensTable")
        .find(".js-delete")
        .on("click", function (e) {
          e.preventDefault();
          var currentAPIId = $(this).data("api-id"),
            $currentRow = $(this).closest("tr");

          self.showRevokeModal(currentAPIId, $currentRow);
        });
    },

    initTranslations: function () {
      this.$el.i18n();
    },

    initFormValidation: function () {
      var self = this;
      $("#form_api_tokens").submit(function (e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      });

      $("#form_api_tokens").bootstrapValidator({
        onSuccess: function (e) {
          e.preventDefault();
          self.save();
        },

        onError: function (e) {
          e.preventDefault();
          self.showError();
        },
      });
    },

    initAlerts: function () {
      if (this.alertView) {
        $("#messages-container").append(this.alertView.render().el);
      }
    },

    initPopovers: function () {
      $(".ayuda-context").popover();
    },

    afterRender: function () {
      BaseView.prototype.afterRender.call(this);

      this.initAlerts();
      this.blockGroupSelector();
      this.initEvents();
      this.initTranslations();
      this.initPopovers();
      this.initFormValidation();
    },

    showRevokeModal: function (apiId, $currentRow) {
      var self = this;
      var modal = new ModalView({
        el: "#modal__container",
        modalExtraStyle: "max-height: 200px;",
        title: "INTEGRATIONS.API_TOKENS.MODAL.REVOKE.TITLE",
        description: "INTEGRATIONS.API_TOKENS.MODAL.REVOKE.DESCRIPTION",
        onSubmit: function () {
          var currentModel = self.collection.filter(function (model) {
            return model.get("id") === apiId.toString();
          });

          if (!currentModel || !currentModel.length) {
            return false;
          }

          // This is only for the UI, not for the model
          self.apiKeysData = self.apiKeysData.filter(function (model) {
            return model.get("id") !== apiId.toString();
          });

          $currentRow.addClass("highlighted").fadeOut(1000, function () {
            currentModel[0].destroy({
              success: function () {
                $currentRow.remove();
                self.render();
              },
              error: function (model, response) {
                self.showAPIError(response.responseJSON);
                $currentRow.removeClass("highlighted").show();
                return false;
              },
              wait: true,
            });
          });
        },
        submitText: "INTEGRATIONS.API_TOKENS.MODAL.REVOKE.BTN_REVOKE",
        onCancel: function () {},
        cancelText: "INTEGRATIONS.API_TOKENS.MODAL.REVOKE.BTN_CANCEL",
      });

      modal.render();
      modal.openModal();
    },

    getSavedModalBody: function (savedData) {
      var secretDataView = new SecretDataView({
        apiData: savedData,
      });

      return secretDataView.render().el;
    },

    showSavedModal: function (savedData) {
      var self = this;
      var modal = new ModalView({
        el: "#modal__container",
        modalExtraStyle: "min-height: 475px;",
        title: "INTEGRATIONS.API_TOKENS.MODAL.SAVE.TITLE",
        description: "INTEGRATIONS.API_TOKENS.MODAL.SAVE.DESCRIPTION",
        body: this.getSavedModalBody(savedData),
        onSubmit: function () {
          self.loadAPIKeys();
        },
        onCancel: function () {
          self.loadAPIKeys();
        },
        submitText: "INTEGRATIONS.API_TOKENS.MODAL.SAVE.BTN_CLOSE",
      });

      modal.render();
      modal.openModal();
    },

    showError: function (responseJSON) {
      var alert = new AlertView({
        el: "#messages-container",
        type: "danger",
        msg_lang:
          responseJSON && responseJSON.title + ": " + responseJSON.detail,
        msg: !responseJSON
          ? "INTEGRATIONS.API_TOKENS.FORM.ERROR_UNEXPECTED"
          : "",
      });

      alert.render();
    },

    showAPIError: function (responseJSON) {
      this.alertView = new AlertView({
        el: "#messages-container",
        type: "danger",
        msg_lang:
          responseJSON && responseJSON.title + ": " + responseJSON.detail,
        msg: !responseJSON
          ? "INTEGRATIONS.API_TOKENS.FORM.ERROR_UNEXPECTED"
          : "",
      });
    },

    getFormData: function () {
      var form = this.$el.find("#form_api_tokens"),
        data = {};

      form.serializeArray().map(function (item) {
        data[item.name] = item.value;
      });

      return data;
    },

    save: function () {
      var self = this;
      var formData = this.getFormData();
      var $formBtnSpinner = this.$el.find("#submitButton").find("i");

      var saveParams = {
          companyId: this.getCurrentCompanyId(),
          serviceId: formData.api_token_service,
          name: formData.api_token_name,
        },
        saveActions = {
          type: "POST",
          success: function (model, response) {
            $formBtnSpinner.hide();
            self.showSavedModal(response);
          },
          error: function (model, response) {
            $formBtnSpinner.hide();
            self.showAPIError(response.responseJSON);
            return false;
          },
          wait: true,
        };

      $formBtnSpinner.show();

      return this.model.save(saveParams, saveActions);
    },
    paymentsRedirect: function () {
      location.href = Config.paymentsUrl + "account/products";
    },
    serialize: function () {
      return {
        apiKeysData: this.apiKeysData || [],
        hasTransActiveServiceGroup: this.group.hasService("Transaccionales"),
        globalAssetsURL: ThemesHelper.getCurrentThemeGlobalURL(),
        isAdmin: this.me.isAdm(),
      };
    },
  });

  module.exports = Layout;
});

